'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DEFAULT_PROPS = {
    size: 24,
    initials: "",
    imageSrc: "",
    foregroundColor: "#72839B",
    backgroundColor: "#E8E8E8",
};

exports.DEFAULT_PROPS = DEFAULT_PROPS;
